import { createFileRoute, redirect } from '@tanstack/react-router'
import { deviceListQuery } from '../../data/devices.ts'

export const Route = createFileRoute('/_app/devices')({
	beforeLoad: async ({ context: { queryClient, impersonation, sub } }) => {
		if (!sub.features.includes('devices') && !impersonation) {
			throw redirect({ to: '/' })
		}
		await queryClient.ensureQueryData(deviceListQuery(impersonation?.partyAccountId))
	},
})
